import { connect } from 'react-redux';
import R from 'ramda';
import { toggleMiniCart } from '@cotyorg/ccx-organism-mini-cart/modules';
import {
  setHeaderFixed,
  toggleCountrySelector,
  toggleSearch,
} from './modules';

const withRedux = headerVariant => (
  connect(
    (state, { cartQuantity }) => ({
      isPinned: state.header.isPinned,
      isCountrySelectorVisible: state.countrySelector.isCountrySelectorVisible,
      isNavigationVisible: state.header.isNavigationVisible,
      content: state.content.header,
      homeLink: state.content.navigation.homeLink,
      cartQuantity: R.pathOr(cartQuantity, ['ecommerce', 'checkout', 'lineItems', 'length'], state),
      cartLink: R.path(['content', 'navigation', 'cartLink'], state),
      currentBreakpoint: R.path(['breakpoints', 'current'], state),
    }),
    dispatch => ({
      setHeaderFixed: isPinned => dispatch(setHeaderFixed(isPinned)),
      toggleCountrySelectorVisibility: () => dispatch(toggleCountrySelector()),
      toggleSearchVisibility: () => dispatch(toggleSearch()),
      toggleMiniCart: props => dispatch(toggleMiniCart(props)),
    }),
  )(headerVariant)
);

export default withRedux;
